<div *ngFor="let item of priorityLevels.reverse()" [class.light]="(value === 0 || value && value != '0')"
  [class.active]="value === item" (click)="value = item;this.change.emit(val);" class="priority-level">
  <font-13 weight="R" size="12" color="primary">{{item | priority}}</font-13>
  <div [style.backgroundColor]="item | priority:'color'"></div>
</div>